export default __webpack_public_path__ + "static/media/change-song.0bb5b4ff.svg";